import { useAppDispatch } from "@grassrootly/rn-core";
import useBaseRequest from "../../api/BaseRequest";
import { authActions } from "../../api/auth/AuthReducer";
import { RefreshAuth } from "@grassrootly/api";
import { useUser } from "../../api/auth/AuthSelector";

export function useAuth() {
  const dispatch = useAppDispatch();
  const user = useUser();

  const { loading, execute: refreshAuth } = useBaseRequest(RefreshAuth, {
    onCompleted(data) {
      if (!data) {
        dispatch(authActions.setUser(null));
        return;
      }
      if (!user) return;
      dispatch(authActions.setUser({ ...user!, user: data.user, auth: data.auth }));
    },
  });

  return { refreshAuth, loading, user };
}
